export default "__VITE_ASSET__NzfcjhX___"